import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PolicyDetailsService } from '../services/policydetails.service';
import { PolicyListingSearchHandler } from './policy-listing-search.handler';

@Component({
  selector: 'sym-policy-listing-search',
  templateUrl: './policy-listing-search.component.html',
  styleUrls: ['./policy-listing-search.component.scss'],
})
export class PolicyListingSearchComponent extends PolicyListingSearchHandler implements OnInit {
  constructor(
    public service: PolicyDetailsService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
